// Object.defineProperty(Object.prototype, 'length', {
//     get: function () {
//         return Object.keys(this).length;
//     },
//     enumerable: false
// });

Object.defineProperty(Object.prototype, 'setDeep', {
    value: function (path, value) {
        var object = this;
        var pList = path.split('.');
        var len = pList.length;

        for (var i = 0; i < len - 1; i++) {
            var elem = pList[i];

            if (! object[elem]) {
                object[elem] = {};
            }

            object = object[elem];
        }

        object[pList[len - 1]] = value;

        return this;
    },
    enumerable: false
});

Object.defineProperty(Object.prototype, 'mapKeys', {
    value: function (iteratee, deep) {
        if (typeof deep === 'undefined') {
            deep = false;
        }
        
        var object = this;
        var result = {};
        
        Object.keys(object).forEach(function (key) {
            var value = object[key];
            var newKey = iteratee(key, value, object);
            
            if (deep && typeof value === 'object') {
                value = value.mapKeys(iteratee, deep);
            }
            
            object[newKey] = value;
            
            if (newKey !== key) {
                delete object[key];
            }
        });
        
        return this;
    },
    enumerable: false
});
